import type { IntlShape } from "react-intl";
import { defineMessages } from "react-intl";

import type { PriceAddOnItemDetails } from "./utils/types";

const UNIT_COST_BASIS_MESSAGES = defineMessages({
  per_item: {
    defaultMessage: "/item",
  },
  per_person: {
    defaultMessage: "/person",
  },
  per_hour: {
    defaultMessage: "/hour",
  },
  flat_fee: {
    defaultMessage: " flat fee",
  },
});

/**
 * Unit price line, e.g. "$50/person ● 4 max". Null when the add-on is priced as
 * a single total rather than per unit.
 */
const formatUnitCostLine = ({
  currency,
  details,
  intl,
}: {
  currency: string;
  details: PriceAddOnItemDetails;
  intl: IntlShape;
}): string | null => {
  if (details.unitCost == null) return null;

  const unitBasisMessage =
    details.unitCostBasis != null &&
    details.unitCostBasis in UNIT_COST_BASIS_MESSAGES
      ? UNIT_COST_BASIS_MESSAGES[
          details.unitCostBasis as keyof typeof UNIT_COST_BASIS_MESSAGES
        ]
      : undefined;

  return intl.formatMessage(
    { defaultMessage: "{price}{optionalLabel} {suffix}" },
    {
      optionalLabel: unitBasisMessage
        ? intl.formatMessage(unitBasisMessage)
        : "",
      price: intl.formatNumber(details.unitCost, {
        style: "currency",
        currency,
      }),
      suffix:
        details.maxCount != null && details.maxCount > 1
          ? intl.formatMessage(
              { defaultMessage: "● {count} max" },
              { count: details.maxCount },
            )
          : "",
    },
  );
};

export { formatUnitCostLine };
